import { AsyncCrudDataGrid } from "src/components/common/dataGrid/crud/AsyncCrudDataGrid.tsx";
import { integerColumn, textColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { ReclamationCategory } from "src/api/generated/erp/db/types/tables/reclamationCategory.ts";
import { dataGridPersistentStateProps } from "src/components/common/dataGrid/dataGridStateStorage.ts";
import { ReclamationCategoryDataGridApi } from "src/api/generated/erp/reclamations/api/reclamationCategoryDataGridApi";

export const ReclamationCategoriesDataGrid = () => {
	return (
		<AsyncCrudDataGrid<ReclamationCategory>
			fetchData={ReclamationCategoryDataGridApi.getAll}
			getRowId={(row) => row.reclamationCategoryId}
			columns={[
				textColumn({
					field: "name",
					headerName: i18n.t("name"),
					editable: true,
					validate: "required",
					minWidth: 300
				}),
				integerColumn({
					field: "reclamationCategoryId",
					headerName: i18n.t("id"),
				}),
			]}
			add={{
				type: "enabled",
				action: async () => {
					return {
						name: "",
					};
				},
			}}
			save={{
				type: "enabled",
				action: async (params) => {
					return await ReclamationCategoryDataGridApi.save({
						reclamationCategories: params.items,
					});
				},
			}}
			remove={{
				type: "enabled",
				action: async (params) => {
					await ReclamationCategoryDataGridApi.delete_({
						reclamationCategories: params.items,
					});
				},
			}}
			{...dataGridPersistentStateProps("C53BB6EE84ED6C21")}
		/>
	);
};
